import { FeedFileDto } from '@/libs/api/feed';
import { ChangeEvent, useCallback, useRef } from 'react';
import Carousel, { CarouselProvider } from '@/components/common/carousel';
import LNImage from '@/components/complex/ln-image';
import Button from '@/components/primitives/button';
import Typography from '@/components/primitives/typography';

import styles from './styles.module.scss';
import ImagePagination from '@/components/complex/image-pagination';

export interface PhotoPickerFile extends FeedFileDto {
  isUploaded: boolean;
  localFile?: File;
  // Base64(Data URL) 원본을 보관
  base64?: string;
  mimeType?: string;
  fileName?: string;
}

export interface PhotoPickerProps {
  photos: PhotoPickerFile[];
  onChange: (photos: PhotoPickerFile[]) => void;
}


const PhotoPicker = (props: PhotoPickerProps) => {
  const ref = useRef<HTMLInputElement>(null);
  const { photos = [] } = props;

  const appendFiles = useCallback((files: File[]) => {
    if (!files || files.length === 0) return;
    const newFiles: PhotoPickerFile[] = files.map((file, index) => {
      const url = URL.createObjectURL(file);
      return {
        id: Date.now() + index,
        file: {
          id: Date.now() + index,
          url,
        },
        localFile: file,
        isUploaded: false,
        sortOrder: photos.length + index,
      } as PhotoPickerFile;
    });
    const updatedFiles = [...photos, ...newFiles];
    props.onChange?.call(null, updatedFiles);
  }, [photos, props]);

  const handlePickPress = useCallback(() => {
    ref.current?.click();
  }, []);

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      appendFiles(Array.from(e.target.files));
    }
  };

  return (
    <div className={styles.photoPickerContainer}>
      <CarouselProvider>
        <div className={styles.images}>
          {photos.length != 0 ? <div>
              <Carousel padding="20px">
                {photos.map((files, index) => (
                  <LNImage
                    key={files.file.url}
                    className={`image ${styles.objectCover}`}
                    source={files.file.url}
                    variant={files.isUploaded ? 'original' : ''}
                    width={480}
                    height={480}
                    alt="등록된 사진"
                  />
                ))}
              </Carousel>
            <ImagePagination size={photos.length} />
            </div> :
            <div className={styles.fallback}>
              <Typography className={`${styles.textBase} ${styles.textCenter}`} size="large" weight="thin">
                {'\'사진 선택\''} 버튼을 누르고<br />
                사진을 1장 이상 추가해주세요
              </Typography>
            </div>
          }
        </div>
      </CarouselProvider>
      <Button rootClassName={styles.button} variant="primary" onClick={handlePickPress}>
        사진 선택
      </Button>
      <input
        ref={ref}
        className={styles.hidden}
        type="file"
        accept="image/*"
        multiple={true}
        onChange={onChange}
      />
    </div>
  );
};

export default PhotoPicker;
